import React from 'react'
import image from '../../assets/homepage_ico1.png'
import image2 from '../../assets/homepage_ico2.png'
import image3 from '../../assets/homepage_ico3.png'
import image4 from '../../assets/homepage_ico4.png'
const Feature = () => {
    const products = [
        {
            "id": 1,
            "name": "Headphone 1",
            "author": "Charles Duhigg",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 2,
            "name": "Headphone 2",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image2
        },
        {
            "id": 3,
            "name": "Headphone 3",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image3
        },
        {
            "id": 4,
            "name": "Headphone 4",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image4
        },
    ]
    return (
        <>
            <ul className="pro-lst">
                {products.map((i,index) => (
                <li key={index}>
                    <div className="bx-img">
                        <img className="img-fluid" src={i.image} alt="" />
                    </div>
                    <div className="prod-txt">
                        <a href="#">
                            <h3>Free Delivery</h3>
                            <h5>For all order over 99$</h5>
                        </a>
                    </div>
                </li>
))}
            </ul>

        </>
    )
}

export default Feature